// Copyright aptihealth, inc. 2019 All Rights Reserved

import moment from "moment-timezone";
import React from "react";
import { withRouter } from "react-router-dom";
import { CardHeading } from "../../UI/Headings";
import { getQueryParams } from "../../../utils/filters";
import Button from "../../UI/Button";
import Label from "../../UI/Label";
import { Select } from "../../UI/StyledInput";
import HeadingPri from "./HeadingPri";
import TimeSlotOption from "./TimeSlotOption";
import TimeslotTile from "./TimeSlotTile";
import {
  DEFAULT_BEHAVIORAL_SCHEDULE_OPTIONS,
  DEFAULT_PRESCRIBER_SCHEDULE_OPTIONS,
} from "../../../utils/calendar/event";
import * as eventConstants from "../../../constants/event";
import { getAutomationDataAttr } from "../../../utils/automationUtils";

const AvailableTimeSlots = (props) => {
  let slotsCount = null,
    morningTimeSlots = [],
    eveningTimeSlots = [];

  let { conf, timeSlots, onConfirmSlotSubmit, timezone } = props;
  const { isDisabled, selectedDate, selectedTimeSlot } = conf;
  const today = moment();
  const todaysDate = today.format("YYYY-MM-DD");
  const currentTime = moment.utc().tz(timezone).format("HHmm"); /** restricting local time to EST */
  let isToday = selectedDate === todaysDate;

  if (timeSlots && isToday) {
    timeSlots = timeSlots.filter((ts) => {
      const timeSlotString = ts.time_slot;
      const trimmedTs = timeSlotString.replace(":", "");
      return trimmedTs > currentTime;
    });
  }

  const cancelSchedule = () => {
    props.history.goBack();
  };

  if (timeSlots && timeSlots.length > 0) {
    slotsCount = timeSlots.length;
    timeSlots.sort().forEach((Slot) => {
      const timeSlotString = Slot.time_slot;
      let localTimeSlot = moment(timeSlotString, "HH:mm").format("hh:mm A");
      let hoursStr = localTimeSlot.substring(6, 8);

      if (hoursStr === "AM") {
        morningTimeSlots.push(
          <TimeSlotOption
            active={selectedTimeSlot}
            displayText={localTimeSlot}
            click={props.click}
            key={timeSlotString}
            timeSlot={Slot}
          />,
        );
      } else {
        eveningTimeSlots.push(
          <TimeSlotOption
            active={selectedTimeSlot}
            displayText={localTimeSlot}
            click={props.click}
            key={timeSlotString}
            timeSlot={Slot}
          />,
        );
      }
    });
  }

  let options;
  if (getQueryParams("providerType", props.location.search) === "Prescriber") {
    options = DEFAULT_PRESCRIBER_SCHEDULE_OPTIONS;
  } else {
    options = DEFAULT_BEHAVIORAL_SCHEDULE_OPTIONS;
  }
  options = options
    .filter(
      (option) => option.value !== eventConstants.AWAY && option.value !== eventConstants.AVAILABLE,
    )
    .map((option) => {
      return {
        value: option.value,
        display: option.label,
      };
    });

  let eventTypeStyleChanges = "";
  if (props.eventType) {
    eventTypeStyleChanges = "_events";
  }

  const timeSlotsAvailable = !props.timeSlotsLoading && timeSlots && timeSlots.length > 0;
  const noTimeSlotsAvailable = !props.timeSlotsLoading && !(timeSlots && timeSlots.length > 0);

  const renderTimeSlotGroup = (timeSlots) => {
    if (props.timeSlotsLoading) {
      return <h6 className="mb-3">Loading...</h6>;
    }
    if (timeSlots.length > 0) {
      return timeSlots;
    }
    return <h6 className="mb-3">No available slot</h6>;
  };

  const renderTimeSlotGroups = () => {
    if (noTimeSlotsAvailable) {
      return (
        <div
          className={"text-center mb-3 mt-3"}
          {...getAutomationDataAttr("Schedule__noTimeSlots")}
        >
          There are no times available for this day.
          <br />
          Please select a new date.
        </div>
      );
    }
    return (
      <>
        <HeadingPri text="Morning" />
        {renderTimeSlotGroup(morningTimeSlots)}
        <HeadingPri text="Afternoon" />
        {renderTimeSlotGroup(eveningTimeSlots)}
      </>
    );
  };

  return (
    <div className="Schedule__TimeSlot-wpr mx-0 mx-md-5">
      <div className={`Schedule__TimeSlot${eventTypeStyleChanges}`}>
        <CardHeading className="mt-2 mb-4 d-none d-lg-block fs-18" text="Available session times" />
        <TimeslotTile
          isToday={isToday}
          dateStr={props.dateStr}
          slotsCount={slotsCount}
          timeSlotsLoading={props.timeSlotsLoading}
        />
        {renderTimeSlotGroups()}
      </div>
      {props.eventType && timeSlotsAvailable && (
        <div className="FormGroup">
          <Label>Select Appointment Type</Label>
          <Select
            name="schedule_type"
            changeHandler={(e) => props.onEventTypeChange(e.target.value)}
            value={props.eventType}
            options={options}
          />
        </div>
      )}
      <div className="Schedule__TimeSlot-Btn-wpr d-flex flex-column flex-xl-row justify-content-xl-between text-center text-xl-left mb-5 mb-xl-0 mx-auto">
        <Button
          className={`Schedule__TimeSlot-Btn${eventTypeStyleChanges} Btn Btn-sm Btn--pri `}
          disabled={isDisabled}
          onClick={onConfirmSlotSubmit}
        >
          Confirm
        </Button>
        <Button
          className={`Schedule__TimeSlot-Btn${eventTypeStyleChanges} Btn Btn-sm Btn--otl-pri `}
          onClick={cancelSchedule}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default withRouter(AvailableTimeSlots);
